import { MatLabel } from '@angular/material/form-field';
import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthorizationScheme, AuthorizationSchemeService, createDtoProperties, DtoComponent, SimpleFormComponent, SimpleFormSectionComponent, SimpleFormRowComponent, MgFormControlDirective, ErrorIconComponent, MgDatetimePickerDirective, MgDatetimePickerToggleComponent, IfCanReadDirective, SubcollectionComponent } from '@mango/core';
import { User } from './user';
import { UserService } from './user.service';
import { LayoutDirective, LayoutGapDirective } from '@ngbracket/ngx-layout/flex';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatInput, MatError, MatSuffix } from '@angular/material/input';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTabGroup, MatTab, MatTabLabel } from '@angular/material/tabs';
import { UserLoginHistoryCollectionComponent } from '../login/login-history/login-history-collection.component';
import { AuthorizationGroupUserCollectionComponent, UserRolesComponent } from '@mango/authorization';


@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LayoutDirective, LayoutGapDirective, SimpleFormComponent, FormsModule, ReactiveFormsModule, SimpleFormSectionComponent, SimpleFormRowComponent, MatFormField, MatLabel, MatInput, MgFormControlDirective, MatError, MatSlideToggle, ErrorIconComponent, MgDatetimePickerDirective, MgDatetimePickerToggleComponent, MatSuffix, MatTabGroup, MatTab, MatTabLabel, IfCanReadDirective, SubcollectionComponent, UserLoginHistoryCollectionComponent, AuthorizationGroupUserCollectionComponent, UserRolesComponent]
})
export class UserComponent extends DtoComponent<User> implements OnInit {
    properties = createDtoProperties<User>([
        "firstName",
        "lastName",
        "email",
        "locked",        
        "lastPasswordChanged",
        "mfaEnabled",
        "isMfaExempt",
        "archivedOn"
    ]);

    myScheme: AuthorizationScheme;
    
    constructor(private userService: UserService, injector: Injector, private authService: AuthorizationSchemeService) {
        super(userService, User);
    }

    ngOnInit() {
        super.ngOnInit();
        this.myScheme = this.authService.getMyScheme();
        this.setCustomActions();

        this.handleRoute("id");
    }

    canDelete(){
        return false;
    }

    isArchived() {
        return (this.item.archivedOn != null);
    }

    canCreate(type: string) {
        return this.myScheme.canCreate(type);
    }

    private setCustomActions() {
        this.buildCustomActions(config => config.add({
            icon: "lock_outline",
            name: "Stuur activatie code",
            fn: () => {
                this.dialogs.confirm("Stuur activatie code", `Hiermee stuurt u een activatie code naar ${this.item.firstName} ${this.item.lastName}, waarmee hij of zij het account kan activeren om vervolgens in te loggen.\n\nWeet u zeker dat u wilt doorgaan?`)
                    .then(ok => {
                        if (ok) {
                            this.userService.sendActivationCode(this.item.id).toPromise()
                                .then(ok => {
                                    if (ok && ok.successfull) {
                                        this.dialogs.alert("Verzonden", "De activatie code is verzonden.", "info_outline");
                                    }
                                    else {
                                        this.dialogs.alert("Fout", "Er is een fout opgetreden, probeer het later nog een keer.", "warning");
                                    }
                                });
                        }
                    });
            },
            isEnabled: () => !this.isNewItem
        }));
    }
}
